// 배달대행료 계산 주체
export const purchaseTypeConst = [
    'DELIVERY_AGENCY',
    'GORELA_REGION',
];
// 주소기반배달 옵션
export default class OrderAgencyOptions {
    /** 주류상품 포함여부 */
    includeAlcohol;
    /** 배차제한건수 */
    allocateLimit;
    /** 배달대행료 계산 주체 */
    purchaseType;
    /** 취소 수수료 */
    cancelFee = null;
    /** 제휴사 서비스 수준 협약 배달 시간 */
    serviceLevelAgreementDeliveryTime = null;
    constructor({ includeAlcohol, allocateLimit, purchaseType, cancelFee, serviceLevelAgreementDeliveryTime, } = {
        includeAlcohol: null,
        allocateLimit: null,
        purchaseType: null,
        cancelFee: null,
        serviceLevelAgreementDeliveryTime: null,
    }) {
        this.includeAlcohol = includeAlcohol;
        this.allocateLimit = allocateLimit;
        this.purchaseType = purchaseType;
        this.cancelFee = cancelFee;
        this.serviceLevelAgreementDeliveryTime = serviceLevelAgreementDeliveryTime;
    }
    get isBundle() {
        if (this.allocateLimit) {
            return this.allocateLimit > 1;
        }
        return false;
    }
}
